import React, { FC } from 'react';
import './NewsPromotionCardSkeleton.scss';

export const NewsPromotionCardSkeleton: FC = () => {
  return (
    <div className="news-promotion-card-skeleton card card__primary">
      <div className="news-promotion-card-skeleton__image skeleton" />
      <div className="news-promotion-card-skeleton__info ">
        <p className="news-promotion-card-skeleton__info__line skeleton" />
        <p className="news-promotion-card-skeleton__info__line skeleton" />
      </div>
    </div>
  );
};
